import { apiURLNew, callAPI } from 'api/main';

import { middlewareUser } from './middleware';

export default async (token?: string): Promise<IUser | null> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/user/private/people/peoples/v1/me`,
      method: 'GET',
      needToken: true,
      forcedToken: token,
      isLegacy: false,
    });

    const { data } = res.request;

    if (data) {
      return middlewareUser(data);
    }

    return null;
  } catch (ex) {
    return null;
  }
};
